<template>
  <div class="bto-sb-event-odds">
    <div class="bto-sb-event-odds-left">
      <div v-if="showEventCode" class="bto-sb-event-code">{{item.eventCode}}</div>
      <div class="bto-sb-event-time">
        <span class="bto-sb-event-inntime">{{item.time}}</span>
        <span class="bto-sb-event-inndate">{{item.date}}</span>
      </div>
      <div class="bto-sb-event-name"
        @mousemove="showOddPopup($event, `${item.homeTeam} ${t('Mobile.VS')} ${item.guestTeam}`)"
        @mouseleave="hideOddPopup">
        <router-link v-bind:title="`${item.homeTeam} ${t('Mobile.VS')} ${item.guestTeam}`" :to="openDetails()">
          <div class="bto-sb-event-wrap">
            <span class="bto-sb-event-team">
              <logo-component v-if="showTeamIcon" v-slot="{ url, reset, onLoad, loaded }" :logo-url="item.homeTeamIcon" >
                <span class="bto-sb-event-team-logo bto-sb-event-hometeam-logo" v-if="url" v-show="loaded">
                  <img :src="url" alt="" @error="reset" @load="onLoad" />
                </span>
              </logo-component>
              <span class="bto-sb-event-home">{{item.homeTeam}}</span>
            </span>
            <span class="bto-sb-event-score-vs">{{t('Mobile.VS')}}</span>
            <span class="bto-sb-event-team">
              <logo-component v-if="showTeamIcon" v-slot="{ url, reset, onLoad, loaded }" :logo-url="item.guestTeamIcon" >
                <span class="bto-sb-event-team-logo bto-sb-event-awayteam-logo" v-if="url" v-show="loaded">
                  <img :src="url" alt="" @error="reset" @load="onLoad" />
                </span>
              </logo-component>
              <span class="bto-sb-event-away">{{item.guestTeam}}</span>
            </span>
          </div>
          <div v-if="eventDescription !== ''" class="bto-sb-event-description">
            {{eventDescription}}
          </div>
        </router-link>
      </div>
    </div>
    <div class="bto-sb-event-odds-right">
      <div class="bto-sb-event-odds-info-cell">
        <span class="bto-sb-event-livestream" v-if="item.hasLiveStream"><i :title="t('Mobile.LiveStream')" class="bto-app-live-stream-o"></i></span>
        <favorite-component v-if="showFavorites" :match="item"></favorite-component>
        <statistics-component v-if="showStatistics" :betRadarId="item.betRadarId" :feedProvider="item.feedProvider" :isAwayAtHome="item.awayAtHome" :isLive="item.isLiveMatch" :sportId="item.sportId" :tournamentName="item.tournamentName"/>
      </div>
      <div class="bto-sb-event-odds-cell">
        <match-odd-component
          v-for="(outcome, index) in firstCol.outcomes"
          v-bind:match="item"
          v-bind:odd="firstCol"
          v-bind:outcome="outcome"
          v-bind:key="index"
          v-bind:is-prematch="true"
          v-bind:is-details="false"/>
      </div>
      <div v-if="showFirstCombo" class="bto-sb-event-odds-cell bto-sb-md-none">
        <span v-if=" !hideSBV && secondCol.outcomes && secondCol.outcomes[0]"
          class="bto-sb-event-odd bto-sb-odd-special bto-sb-event-odd-special">
          {{secondCol.outcomes[0].sbv || '--'}}
        </span>
        <match-odd-component
          v-for="(outcome, index) in secondCol.outcomes"
          v-bind:match="item"
          v-bind:odd="secondCol"
          v-bind:outcome="outcome"
          v-bind:key="index"
          v-bind:is-prematch="true"
          v-bind:is-details="false"/>
      </div>
      <div v-if="showSecondCombo" class="bto-sb-event-odds-cell bto-sb-lg-none">
        <span v-if=" !hideThirdColSBV && thirdCol.outcomes && thirdCol.outcomes[0]"
          class="bto-sb-event-odd bto-sb-odd-special bto-sb-event-odd-special">
          {{thirdCol.outcomes[0].sbv || '--'}}
        </span>
        <match-odd-component
          v-for="(outcome, index) in thirdCol.outcomes"
          v-bind:match="item"
          v-bind:odd="thirdCol"
          v-bind:outcome="outcome"
          v-bind:key="index"
          v-bind:is-prematch="true"
          v-bind:is-details="false"/>
      </div>
      <a class="bto-sb-event-odds-cell bto-sb-event-more-odd"
        :class="{'bto-sb-event-more-odd-active': showDetails, 'bto-sb-event-more-cash' : cashOutVisibility}"
        @click="toggleDetails()">
        +{{showMarketsInMatch === true ? item.numberOfMarkets : item.numberOfOdds}}
        <i class="bto-app-cash" v-if="cashOutVisibility"></i>
      </a>
    </div>
    <embeded-match-details
      v-bind:matchIdProp="item.matchId"
      v-bind:matchTypeProp="`prematch`"
      v-if="showDetails === true">
    </embeded-match-details>
  </div>
</template>

<script>
  import MatchOddComponent from '../match/match-odd-component';
  import EmbededMatchDetails from '../../widgets/match-details/prematch/embeded-match-details';
  import FavoriteComponent from '../../shared/favorite-component';
  import StatisticsComponent from '../../common/statistics-component';
  import OddHelperService from '../../../services/odd-helper-service';
  import { EventBus } from '../../../services/event-bus-service';
  import store from '../../../store';
  import { urlFriendlyParam } from '@bto-services/utils';

  export default {
    name: 'MatchItemComp',
    data() {
      return {
        showDetails: false,
      };
    },
    props: {
      is3WaySport: {
        type: Boolean,
        default: true,
      },
      item: {
        type: Object,
        default: () => {
        },
      },
      template: {
        type: String,
        default: 'default',
      },
      showFirstCombo: {
        type: Boolean,
        default: false,
      },
      showSecondCombo: {
        type: Boolean,
        default: false,
      },
      firstComboOddType: {
        type: Object,
        default: () => {
        },
      },
      secondComboOddType: {
        type: Object,
        default: () => {
        },
      },
      showMarketsInMatch: {
        type: Boolean,
        default: false,
      },
      showEventCode: {
        type: Boolean,
        default: false,
      },
      showTeamIcon: {
        type: Boolean,
        default: false,
      },
      showFavorites: {
        type: Boolean,
        default: false,
      },
      showStatistics: {
        type: Boolean,
        default: false,
      },
      eventDescription: {
        type: String,
        default: '',
      },
      singleMarketView: {
        type: Boolean,
        default: false,
      },
    },
    computed: {
      cashoutEnabledDB() {
        return store.getters.getCashoutDbSetting;
      },
      /**
       * cash out visibility on match level
       */
      cashoutEnabledUser() {
        return store.state.playerInfoModule.playerInfo.cashout;
      },
      cashOutVisibility() {
        return this.cashoutEnabledDB && this.item.cashOutVisibility &&
          (!APP_SETTINGS.player.token || this.cashoutEnabledUser);
      },
      /**
       * Outcomes shown for the first market displayed
       */
      firstCol() {
        // if there are no outcomes for the column add empty outcomes
        return this.item.odds[0] && this.item.odds[0].outcomes.length > 0 ?
          this.item.odds[0] :
          OddHelperService.generateEmptyOutcomes(this.is3WaySport ? 3 : 2, false);
      },
      /**
       * Outcomes shown for the first combo ( the second market displayed)
       */
      secondCol() {
        if (typeof this.firstComboOddType.o === 'undefined') {
          return {};
        }
        let secondColOdds = this.item.odds.filter(market => market.marketId === this.firstComboOddType.ot)[0];
        return OddHelperService.getOrderedOutcomes(secondColOdds, this.firstComboOddType);
      },
      /**
       * Outcomes shown for the second combo ( the third market displayed)
       */
      thirdCol() {
        if (typeof this.secondComboOddType.o === 'undefined') {
          return {};
        }
        let trhirdColOdds = this.item.odds.filter(market => market.marketId === this.secondComboOddType.ot)[0];
        // order the outcomes according to the  order in the header.
        return OddHelperService.getOrderedOutcomes(trhirdColOdds, this.secondComboOddType);
      },
      hideSBV() {
        return !this.firstComboOddType.mb && !this.firstComboOddType.sbv;
      },
      hideThirdColSBV() {
        return !this.secondComboOddType.mb && !this.secondComboOddType.sbv;
      },
    },
    methods: {
      openDetails() {
        const rawSportName = store.getters.getSportName(this.item.sportId);
        const sportName = urlFriendlyParam(rawSportName);
        const eventName = urlFriendlyParam(`${this.item.homeTeam} vs ${this.item.guestTeam}`);
        const categoryName = urlFriendlyParam(this.item.tournamentName);
        return { name: 'seoGame', params: { sportName, categoryName, eventName, matchId: this.item.matchId } };
      },
      toggleDetails() {
        this.showDetails = !this.showDetails;
      },
      /**
       * if match has an odd with combinability display the legend in the widget
       */
      showCombinabilityLeg(flag) {
        this.$emit('showCombsLeg', flag);
      },
      showOddPopup(event, msg) {
        EventBus.$emit('showoddmarketpopup', {
          message: msg,
          e: event
        });
      },
      hideOddPopup() {
        EventBus.$emit('hideoddmarketpopup');
      }
    },
    components: {
      MatchOddComponent,
      EmbededMatchDetails,
      FavoriteComponent,
      StatisticsComponent,
    },
  };
</script>
